<div *ngIf="distis && !selectedDisti">

	<div class="row">
		<h6 class="text-dark float-right">Select a Partner</h6>
		<!-- <mat-form-field class="col-xl-4 col-md-6 ml-auto pt-0" style="margin-top: -15px">
			<input matInput placeholder="search...">
		</mat-form-field> -->
	</div>
	<div mat-dialog-content>

		<p *ngIf="noDisti" class="mx-auto text-center mt-3">No records found</p>

		<div class="row justify-content-center mb-4 mt-3 mb-3">
			<div class="card pointer select-card mt-3 ml-3 mr-3" *ngFor="let item of distis">
				<div class="card-body" (click)="onDisti(item)">{{item.name}}</div>
			</div>
		</div>
	</div>
	<div mat-dialog-actions class="justify-content-end mt-5">
		<button class="mr-3" type="button" mat-raised-button
				color="warn" [mat-dialog-close]="">
				Cancel
		</button>
	</div>
</div>

<div *ngIf="selectedDisti && selectedDisti.disti_id != null && markets && !selectedMarket && !selectedClient">
	<div class="row">
		<h6 class="text-dark float-right">Select a Market</h6>
		<!-- <mat-form-field class="col-xl-4 col-md-6 ml-auto pt-0" style="margin-top: -15px">
			<input matInput placeholder="search...">
		</mat-form-field> -->
	</div>
	<div mat-dialog-content>

		<p *ngIf="noMarket" class="mx-auto text-center mt-3">No records found</p>

		<div class="row justify-content-center mb-4">
			<div class="card pointer select-card  mt-3 ml-3 mr-3" *ngFor="let item of markets">
				<div class="card-body" (click)="onMarket(item)">{{item.market_name}}</div>
			</div>
		</div>
	</div>
  <div mat-dialog-actions>
	<button *ngIf="data.bckBtn" type="button" class="float-left" (click)="onBack('disti')" mat-raised-button>
		back
	</button>
	<button type="button" class="ml-auto mr-3" mat-raised-button
			color="warn" [mat-dialog-close]="">
			close
	</button>
  </div>

</div>

<div *ngIf="clients && !selectedClient && (selectedMarket || selectedDisti?.disti_id == null || selectedDisti)">
	<div class="row">
		<h6 class="text-dark float-right">Select a Client</h6>
		<!-- <mat-form-field class="col-xl-4 col-md-6 ml-auto pt-0" style="margin-top: -15px">
			<input matInput placeholder="search...">
		</mat-form-field> -->
	</div>
	<div mat-dialog-content>

		<p *ngIf="noClient" class="mx-auto text-center mt-3">No records found</p>

		<div class="row justify-content-center mb-4">
			<div class="card pointer select-card  mt-3 ml-3 mr-3" *ngFor="let item of clients">
				<div class="card-body" (click)="onClient(item)">{{item.company_name}}</div>
			</div>
		</div>
	</div>
  <div mat-dialog-actions>
	<button *ngIf="data.bckBtn && selectedDisti?.disti_id != null" type="button" class="float-left" (click)="onBack('market')" mat-raised-button>
		back
	</button>
	<button *ngIf="data.bckBtn && selectedDisti?.disti_id == null" type="button" class="float-left" (click)="onBack('disti')" mat-raised-button>
		back
	</button>
	<button type="button" class="ml-auto mr-3" mat-raised-button
			color="warn" [mat-dialog-close]="">
			close
	</button>
  </div>

</div>

<div *ngIf="selectedClient && campuses">
	<div class="row">
		<h6 class="text-dark float-right">Select a Campus</h6>
		<!-- <mat-form-field class="col-xl-4 col-md-6 ml-auto pt-0" style="margin-top: -15px">
			<input matInput placeholder="search...">
		</mat-form-field> -->
	</div>
	<div mat-dialog-content>

		<p *ngIf="noCampus" class="mx-auto text-center mt-3">No records found</p>

		<div class="row justify-content-center mb-4">
			<div class="card pointer select-card  mt-3 ml-3 mr-3" *ngFor="let item of campuses">
				<div class="card-body" (click)="onCampus(item)">{{item.name}}</div>
			</div>
		</div>
	</div>
  <div mat-dialog-actions>
	<button *ngIf="data.bckBtn" type="button" class="float-left"  (click)="onBack('client')" mat-raised-button>
		back
	</button>
	<button type="button" class="ml-auto mr-3" mat-raised-button
				color="warn" [mat-dialog-close]="">
				close
			</button>
  </div>

</div>

